import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { profile } from "../data/profile";
import { socialLinks } from "../data/socialLinks";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-main">
        <Link className="footer-mark" to="/"><span>{profile.initials}</span><strong>{profile.name}</strong></Link>
        <p>Intelligent systems, built from research to working software and robots.</p>
        <div>{socialLinks.slice(0, 2).map((link) => <a key={link.label} href={link.href} target="_blank" rel="noreferrer">{link.label}<ArrowUpRight aria-hidden="true" /></a>)}</div>
      </div>
      <div className="shell footer-base">
        <span>© {new Date().getFullYear()} {profile.name}</span>
        <span>Designed & engineered in Darmstadt</span>
        <a href="#main-content">Back to top ↑</a>
      </div>
    </footer>
  );
}
